// NPM Imports
import React from "react";
import { connect } from "react-redux";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Components Imports
import DocumentForwardingSetting from "./DocumentForwardingSetting";
import FormFieldsSetting from "./FormFieldsSetting";
import EsignExpiryDocSettings from "./EsignExpiryDocSettings";
// Actions Imports
import { QuotationActions } from "../../actions";
import { DOCUMENT_STAGES } from "../QuotationTopBarV3/Constants";

// SERVICE Imports

// Internal Imports

// Destructuring
const { updateToolPaneData } = QuotationActions;

const DocumentSettings = props => (
  <div className="documentsettings-container animated fadeinright">
    <div className="documentsettings-header">
      <span>Settings</span>

      {/* <span className="recipient-side-documentsettings-close-btn">
        <FontAwesomeIcon
          icon={["far", "times"]}
          onClick={() => props.updateToolPaneData(false, "")}
          className=""
        />
      </span> */}
    </div>
    <div className="documentsettings-body-wrapper">
      <div className="content-scroll">
        <div className="documentsettings-box">
          {props.mode === "DOCUMENT" && <DocumentForwardingSetting />}
          {!props.isPdfDocument && (
            <FormFieldsSetting mode={props.mode} showHeading />
          )}
          {props.mode === "DOCUMENT" && props.shouldShowEsignEpiry && (
            <EsignExpiryDocSettings mode={props.mode} />
          )}
        </div>
      </div>
    </div>
  </div>
);

const mapStateToProps = state => {
  const {
    document: { isPdfDocument, stage: docStage },
  } = state.DocumentStore;

  const shouldShowEsignEpiry =
    docStage !== DOCUMENT_STAGES.DRAFT &&
    docStage !== DOCUMENT_STAGES.COMPLETED &&
    docStage !== DOCUMENT_STAGES.DECLINED;

  return { isPdfDocument, shouldShowEsignEpiry };
};

const mapDispatchToProps = {
  updateToolPaneData,
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentSettings);
